import { UpdateRemovalListDateTimeModel } from './../models/update-removal-list-datetime.model';
import { UpdateRemovalListModel } from './../models/update-removal-list.model';
import {RemovalListModel } from './../models/removal-list.model';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {BACKEND_KEYS, BACKEND_METHOD_CONSTANT, BACKEND_METHOD_TYPES, URL_CONSTANT} from './url-constant';

import {SiteModel} from '../models/site.model';
import {BaseAPI} from './baseAPI';
import {ServerModel} from '../models/server.model';
import {AuthService} from './auth.service';
import {map} from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { SensorsiteModel } from '../models/sensorsite.model';
import { Time } from '@angular/common';

@Injectable()
export class SitesService extends BaseAPI {
  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }
  // username: string = this.authService.user.username;
  // password: string = this.authService.user.password;
  getAvailableSites(
    username: string = this.authService.user.username,
    password: string = this.authService.user.password,
  ): Observable<SiteModel[]> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, username)
      .set(BACKEND_KEYS.pass, password);

    return this.get(BACKEND_METHOD_CONSTANT.availableSites, httpParams)
      .pipe(
        map((sites: SiteModel[]) => {
          return sites ? sites : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSite(siteId: number): Observable<SiteModel> {
    const httpParams = this.getBaseHttpParams().set(
      BACKEND_KEYS.siteId,
      siteId.toString()
    );

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.get;

    return this.get(url, httpParams)
      .pipe(
        map((site: SiteModel) => {
          return site ? site : undefined;
        })
      )
      .catch(this.handleError);
  }

  // getSites(): Observable<SiteModel[]> {
  //   const httpParams = this.getBaseHttpParams();
  //
  //   const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.list;
  //
  //   return this.get(url, httpParams).map((sites: SiteModel[]) => {
  //     return sites ? sites : undefined;
  //   })
  //     .catch(this.handleError);
  // }

  getSensorSites(sites: SensorsiteModel[]): Observable<SiteModel[]> {
    const requests = [];
    for (const site of sites) {
      const siteId = site.siteId;
      const httpParams = this.getBaseHttpParams().set(
        BACKEND_KEYS.siteId,
        siteId.toString()
      );
      const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.get;
      requests.push(this.get(url, httpParams));
      //  console.log('from getSensorSites service', this.get(url, httpParams));
    }
    return forkJoin(...requests)
      .pipe(
        map((sitess: SiteModel[]) => {
          // console.log('from getSensorSites service', sitess);
          return sitess ? sitess : undefined;
        })
      )
      .catch(this.handleError);
  }

  getSites(serverId?: number, sensorId?: number): Observable<SiteModel[]> {
    let httpParams = this.getBaseHttpParams();

    if (serverId != null) {
      httpParams = httpParams.set(BACKEND_KEYS.serverId, String(serverId));
    }
    if (sensorId != null) {
      httpParams = httpParams.set(BACKEND_KEYS.sensorId, String(sensorId));
    }

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams)
      .pipe(
        map((sites: SiteModel[]) => {
          return sites ? sites : undefined;
        })
      )
      .catch(this.handleError);
  }

  createSite(site: SiteModel): Observable<SiteModel> {
    const httpParams = this.getBaseHttpParams();

    // @weakify(self);

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.create;

    // console.log(site)

    return this.post(url, httpParams, site)
      .pipe(
        map((newsite: SiteModel) => {
          return newsite ? newsite : undefined;
        })
      )
      .catch(this.handleError);
  }

  updateSite(site: SiteModel): Observable<SiteModel> {
    const httpParams = this.getBaseHttpParams();

    //    @weakify(self);

    // console.log(site)

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.update;

    return this.put(url, httpParams, site)
      .pipe(
        map((newsite: SiteModel) => {
          // console.log(newsite);
          return newsite ? newsite : undefined;
        })
      )
      .catch(this.handleError);
  }

  deleteSite(siteId: number): Observable<SiteModel> {
    const httpParams = this.getBaseHttpParams().set(
      BACKEND_KEYS.siteId,
      siteId.toString()
    );

    // console.log(httpParams);

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.delete;

    return this.delete(url, httpParams).catch(this.handleError);
  }

  getSiteFromId(siteId: number, sites: SiteModel[]): SiteModel {
    for (const site of sites) {
      if (siteId === site.id) {
        return site;
      }
    }
    return null;
  }

  getCorrectionFactorSubstitution(siteId: number): Observable<any> {
    const httpParams = this.getBaseHttpParams().set(
      BACKEND_KEYS.siteId,
      String(siteId)
    );

    const url = BACKEND_METHOD_CONSTANT.correctionFactorSubstitution;

    return this.get(url, httpParams)
      .pipe(
        map((site) => {
          return site ? site : undefined;
        })
      )
      .catch(this.handleError);
  }

  createCorrectionFactorSubstitution(
    siteId: number,
    sourceSiteId: number
  ): Observable<any> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.siteId, String(siteId))
      .set(BACKEND_KEYS.sourceSiteId, String(sourceSiteId));

    const url = BACKEND_METHOD_CONSTANT.correctionFactorSubstitution;

    return this.post(url, httpParams)
      .pipe(
        map((sourceSite) => {
          return sourceSite ? sourceSite : undefined;
        })
      )
      .catch(this.handleError);
  }

  deleteCorrectionFactorSubstitution(
    siteId: number,
    sourceSiteId: number,
  ): Observable<any> {
    const httpParams = this.getBaseHttpParams()
      .set(BACKEND_KEYS.siteId, String(siteId))
      .set(BACKEND_KEYS.sourceSiteId, String(sourceSiteId));

    const url = BACKEND_METHOD_CONSTANT.correctionFactorSubstitution;

    return this.delete(url, httpParams).catch(this.handleError);
  }

  getSitesFromModuleId(moduleId: number): Observable<SiteModel[]> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform().set(
      BACKEND_KEYS.moduleId,
      String(moduleId)
    );

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams)
      .pipe(
        map((site) => {
          return site ? site : undefined;
        })
      )
      .catch(this.handleError);
  }
  associteSitetoCheckpointServer(serverId: number): Observable<SiteModel[]> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform().set(
      BACKEND_KEYS.checkpointServerId,
      String(serverId),
    );

    const url = BACKEND_METHOD_CONSTANT.site + BACKEND_METHOD_TYPES.update;

    return this.get(url, httpParams)
      .pipe(
        map((site) => {
          return site ? site : undefined;
        })
      )
      .catch(this.handleError);
  }

  getRemovalList(siteId: number): Observable<any> {
    const httpParams = this.getBaseHttpParamsWithoutPlatform()
    .set(BACKEND_KEYS.siteId, String(siteId),
    );

    const url = BACKEND_METHOD_TYPES.removalList;

    return this.get(url, httpParams)
      .pipe(
        map((removalList) => {
          return removalList ? removalList : undefined;
        }),
      )
      .catch(this.handleError);
}

deleteRemovalListFromSite(siteId): Observable<RemovalListModel> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId))

  const url = BACKEND_METHOD_TYPES.UpdateRemovalList;

  return this.delete(url, httpParams)
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}
// tslint:disable-next-line: max-line-length
updateRemovalList(siteId: number, updateRemoval: UpdateRemovalListModel, update: string): Observable<RemovalListModel> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId))
  .set(BACKEND_KEYS.num_days_back, String(updateRemoval.num_days_back))
  .set(BACKEND_KEYS.num_days_present, String(updateRemoval.num_days_present))
  .set(BACKEND_KEYS.min_duration_sec, String(updateRemoval.min_duration_sec))
  .set(BACKEND_KEYS.max_duration_sec, String(updateRemoval.max_duration_sec))
  .set(BACKEND_KEYS.start_time, String(updateRemoval.start_time))
  .set(BACKEND_KEYS.end_time, String(updateRemoval.end_time))
  .set(BACKEND_KEYS.reason, String(updateRemoval.reason))
  .set(BACKEND_KEYS.update, String(update))
  .set(BACKEND_KEYS.siteId, String(siteId));

  const url = BACKEND_METHOD_TYPES.UpdateRemovalList;

  return this.get(url, httpParams)
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}

addDeviceToRemoval(siteId: number, visitorId: number): Observable<any> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId))
  .set(BACKEND_KEYS.visitor_id, String(visitorId))
  .set(BACKEND_KEYS.siteId, String(siteId));

  const url = BACKEND_METHOD_TYPES.addDeviceToRemovalList;

  return this.get(url, httpParams)
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}
removeDeviceFromRemoval(siteId: number, visitorId: number): Observable<any> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId))
  .set(BACKEND_KEYS.visitor_id, String(visitorId))
  .set(BACKEND_KEYS.siteId, String(siteId));

  const url = BACKEND_METHOD_TYPES.removeDeviceToRemovalList;

  return this.get(url, httpParams)
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}

updateRemovalListDateTime(siteId: number, updateRemoval: UpdateRemovalListDateTimeModel): Observable<any> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId))
  .set(BACKEND_KEYS.startTime, String(updateRemoval.startTime))
  .set(BACKEND_KEYS.endTime, String(updateRemoval.endTime))
  .set(BACKEND_KEYS.reason, String(updateRemoval.reason))
  .set(BACKEND_KEYS.update, String(updateRemoval.update))
  .set(BACKEND_KEYS.siteId, String(siteId));

  const url = BACKEND_METHOD_TYPES.updateRemovalListDateTime;

  return this.get(url, httpParams)
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}

getRemovalListScheduler(siteId: number): Observable<any> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId));

  const url = BACKEND_METHOD_TYPES.removeDeviceToRemovalList;

  return this.get(url, httpParams)
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}

postRemovalListScheduler(siteId: number, id: number, updateRemoval: UpdateRemovalListModel): Observable<any> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.siteId, String(siteId))
  .set(BACKEND_KEYS.id, String(id))
  .set(BACKEND_KEYS.num_days_back, String(updateRemoval.num_days_back))
  .set(BACKEND_KEYS.num_days_present, String(updateRemoval.num_days_present))
  .set(BACKEND_KEYS.min_duration_sec, String(updateRemoval.min_duration_sec))
  .set(BACKEND_KEYS.max_duration_sec, String(updateRemoval.max_duration_sec))
  .set(BACKEND_KEYS.start_time, String(updateRemoval.start_time))
  .set(BACKEND_KEYS.end_time, String(updateRemoval.end_time))
  .set(BACKEND_KEYS.reason, String(updateRemoval.reason))
  .set(BACKEND_KEYS.siteId, String(siteId));
  const url = BACKEND_METHOD_TYPES.removeDeviceToRemovalList;

  return this.post(url, httpParams )
    .pipe(
      map((removalList) => {
        return removalList ? removalList : undefined;
      }),
    )
    .catch(this.handleError);
}

deleteRemovalListScheduler(id: number): Observable<any> {
  const httpParams = this.getBaseHttpParamsWithoutPlatform()
  .set(BACKEND_KEYS.id, String(id));

  const url = BACKEND_METHOD_TYPES.removeDeviceToRemovalList;

  return this.delete(url, httpParams).catch(this.handleError);

}
}
